import { ChangeEvent, useState } from "react";

interface FileUploaderProps {
  setFiles: (files: File[]) => void;
}

// Allowed File-Types (MIME-Types) and there Endings for possible errors
const ACCEPTED_MIME_TYPES = [
  // Texts/Documents
  "text/plain",
  "text/markdown",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  // Tables
  "text/csv",
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  // Images
  "image/jpeg",
  "image/png",
  "image/webp",
];

// Fallback-Check over file endings in case browser gives no mime-type
const ACCEPTED_EXTENSIONS = [
  ".txt", ".md", ".pdf", ".docx",
  ".csv", ".xls", ".xlsx",
  ".jpg", ".jpeg", ".png", ".webp",
];

const ACCEPT_ATTRIBUTE = [
  ".txt", ".md", ".pdf", ".docx", ".csv", ".xlsx",
  "image/jpeg", "image/png", "image/webp",
].join(",");

function isFileTypeAllowed(file: File): boolean {
  if (ACCEPTED_MIME_TYPES.includes(file.type)) {
    return true;
  }
  const extension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
  return ACCEPTED_EXTENSIONS.includes(extension);
}

export default function FileUploader({ setFiles } : FileUploaderProps){
    const[fileNames, setFileNames] = useState<string[]>([]);
    const[error, setError] = useState<string|null>(null);

    function handleFileChange(e: ChangeEvent<HTMLInputElement>) {
        const selectedFiles = Array.from(e.target.files ?? []);
        const validFiles : File[] = [];
        const invalidFileNames : string[] = [];

        for (const file of selectedFiles) {
            if (isFileTypeAllowed(file)) {
                validFiles.push(file);
            } else {
                invalidFileNames.push(file.name);
            }
        }

        if (invalidFileNames.length > 0) {
            setError(
                `Nicht unterstützter Dateityp bei: ${invalidFileNames.join(", ")}. ` +
                `Erlaubt sind: TXT, MD, PDF, DOCX, CSV, XLSX, JPG, PNG, WEBP.`
            );
        } else {
            setError(null);
        }

        setFiles(validFiles);
        setFileNames(validFiles.map((file) => file.name));

        // Erlaubt erneuten Upload derselben Datei nach einem Fehler
        e.target.value = "";
    }

    return (
    <div className="file-input-wrapper">
      <label className="file-input-label">
        Alle Dateien auswählen
        <input
          type="file"
          multiple
          accept={ACCEPT_ATTRIBUTE}
          className="file-input-hidden"
          onChange={handleFileChange}
        />
      </label>
      {fileNames.length > 0 && <span className="file-input-filename">{fileNames.join(", ")}</span>}
      {error && <span className="file-input-error">{error}</span>}
    </div>
    );
}